<template>
  <div class="bottom-outer" :style="{background: `url(${bgSrc}) center center / cover no-repeat`,color:color}">
    <div class="num">{{num}}</div>
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  props:{
    bgSrc:String,
    color:String,
    title:String,
    num:Number,
  }
}
</script>

<style lang="scss" scoped>
.bottom-outer{
  display: flex;
  width: 134px;
  height: 105px;
  flex-direction: column;
  align-items: center;
  .num{
    font-size: 24px;
    font-weight: bold;
    margin: 10px 0;
  }
  .title{
    font-size: 14px;
  }
}
</style>